"use client"

// src/components/icon.ts
var Icon = {
  baseStyle: {
    color: "currentColor",
    display: "inline-block",
    flexShrink: 0,
    h: "1em",
    lineHeight: "1em",
    w: "1em"
  }
};

export {
  Icon
};
//# sourceMappingURL=chunk-3XXSDWNS.mjs.map